import React from 'react';
import useSetTitle from "../../hooks/useSetTitle";
import { Form, Input, Button, Divider, message } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { useAppSelector } from "../../hooks/redux";
import { RootState } from "../../store/store";
import style from './Settings.module.scss';

const Settings = () => {
    useSetTitle('Настройки аккаунта');
    const userInfo = useAppSelector((state: RootState) => state.userinfo);
    const [form] = Form.useForm();

    const onFinish = (values: any) => {
        console.log('Success:', values);
        message.success('Настройки успешно сохранены');
    };

    return (
        <div className={style.container}>
            {/* <div className={style.profileHeader}>
                <div className={style.avatarLarge}>
                    {userInfo.firstname?.[0]}{userInfo.lastname?.[0]}
                </div>
                <div className={style.info}>
                    <h2>{`${userInfo.lastname} ${userInfo.firstname} ${userInfo.middlename}`}</h2>
                    <p>Сотрудник ГГНТУ</p>
                </div>
            </div>

            <div className={style.card}>
                <div className={style.cardTitle}>
                    <UserOutlined /> Основная информация
                </div>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    initialValues={{
                        username: userInfo.id, // или login если есть в стейте
                        email: 'example@ggntu.ru'
                    }}
                >
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                        <Form.Item label="Логин" name="username">
                            <Input prefix={<UserOutlined />} disabled />
                        </Form.Item>
                        <Form.Item label="Электронная почта" name="email">
                            <Input prefix={<MailOutlined />} placeholder="email@ggntu.ru" />
                        </Form.Item>
                    </div>
                    <Button type="primary" htmlType="submit" className={style.saveBtn}>
                        Сохранить изменения
                    </Button>
                </Form>
            </div>

            <div className={style.card}>
                <div className={style.cardTitle}>
                    <SafetyCertificateOutlined /> Безопасность
                </div>
                <Form layout="vertical" onFinish={() => message.info('Функционал смены пароля в разработке')}>
                    <Form.Item label="Текущий пароль" name="oldPassword">
                        <Input.Password prefix={<LockOutlined />} placeholder="••••••••" />
                    </Form.Item>
                    <Divider />
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                        <Form.Item label="Новый пароль" name="newPassword">
                            <Input.Password prefix={<LockOutlined />} placeholder="Минимум 8 символов" />
                        </Form.Item>
                        <Form.Item label="Подтвердите пароль" name="confirmPassword">
                            <Input.Password prefix={<LockOutlined />} placeholder="Повторите новый пароль" />
                        </Form.Item>
                    </div>
                    <Button type="primary" htmlType="submit" className={style.saveBtn}>
                        Обновить пароль
                    </Button>
                </Form>
            </div> */}
        </div>
    );
};

export default Settings;
